import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { HttpClient } from '@angular/common/http';
import {
  IDriverMapMarker,
  IDriverMapMarkerFilter,
  IDriverMapTaskETA,
  IDriverMapTaskHistory,
  IDriverMapTaskRoute,
} from '../interfaces/driver-location';
import { BaseDataService } from './base.data.service';
import { Observable } from 'rxjs-compat';

@Injectable({ providedIn: 'root' })
export class IDriverLocationService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  url = '/api/map/driver_locations';

  search(filterCommand: IDriverMapMarkerFilter = {}): Promise<IDriverMapMarker[]> {
    return this.http
      .get<IDriverMapMarker[]>(`${this.url}`, { params: this.constructHttpParams(filterCommand) })
      .toPromise();
  }

  historySearch(filterCommand: IDriverMapMarkerFilter = {}): Promise<IDriverMapTaskHistory[]> {
    return this.http
      .post<IDriverMapTaskHistory[]>(`/api/map/driver_history`, {
        filters: filterCommand.filters,
      })
      .toPromise();
  }

  getTaskRoutes(taskIds: any): Promise<IDriverMapTaskRoute[]> {
    return this.http.post<IDriverMapTaskRoute[]>(`/api/map/task_routes`, { taskIds }).toPromise();
  }

  getTaskLiveETA(taskId: number, lat: number, lng: number): Promise<any> {
    return this.http
      .get<IDriverMapTaskETA>(`/api/task/` + taskId + '/liveETA/' + lat + '/' + lng)
      .toPromise();
  }
}
